import { useRoutes, Navigate } from 'react-router-dom';

// project import
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import config from 'config/config';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([
        LoginRoutes,
        MainRoutes,
        {path: '*', element: <Navigate to={config.config.defaultPath} />} // Default route
    ]);
}
